export const AUTH_TOKEN = 'token'